import { useIntl } from "react-intl";
import React, { useState, useRef, CSSProperties, useEffect, useMemo, useCallback } from "react";
import DentalRecord1UX, { HotSpot } from "react-lib/apps/common/CUDENT/DentalRecordUX";
import DentalRecordNoBaby1UX, { HotSpotNoBaby } from "react-lib/apps/common/CUDENT/DentalRecordNoBabyUX";
import { Button, Icon, Modal, Form } from "semantic-ui-react";
import DentalExam from "../DentalExam";
import toothDetails from "react-lib/apps/common/CUDENT/ToothDetails";
import {
  getAbbrSurface,
  getSurfaceName,
  getOrgansWithRecord,
  superTeethTSOrganToTSHuman,
  superTeethTSHumanToTSOrgan,
  superTeethSHumanToSOrgan,
  superTeethSOrganToSHuman,
  deTinyLocation2,
  getSurfaceBorderLine,
  clinicalHasBabyTooth,
} from "react-lib/apps/common/CUDENT/DentalRecordUtil";
import { MissingToothClinical, PartialMissingToothClinical } from "../DiagnosisTodayInterface";
import { CARDNAME as DIAGNOSIS_TODAY_CARD } from "../DiagnosisToday";
import { getOnlyFullTeeth } from "react-lib/apps/common/CUDENT/DentalRecordUtil";
import ExaminationImageOverlay, { Tooltip } from "./ExaminationImageOverlay";
import { getEffectiveZoom, getViewportRect } from "./screenGeometry";

const DENTAL_DIAGRAM = "Dental Diagram";

const DentalRecord1 = (props) => {
  const intl = useIntl();
  let tooltipRef = useRef<any>();
  const [selecting, setSelecting] = useState(false);
  const [startPoint, setStartPoint] = useState(null);
  const [endPoint, setEndPoint] = useState(null);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  // const [chooseMissingTeeth, setChooseMissingTeeth] = useState(false);
  const [chooseSupernumerary, setChooseSupernumerary] = useState(false);
  const [openGallery, setOpenGallery] = useState(false);
  const [openPhysicalExam, setOpenPhysicalExam] = useState(false);

  const [organMaster, setOrganMaster] = useState(null);
  const [superteethPatient, setSuperTeethPatient] = useState([]); // e.g. TS12S13
  const [colorTag, setColorTag] = useState([]);
  const [hideBabyTooth, setHideBabyTooth] = useState(!!props.hideBabyTooth);

  // const [offsetTop, setOffsetTop] = useState(0)
  // const [offsetLeft, setOffsetLeft] = useState(0)

  // const [toothFilter, setToothFilter] = useState("")

  const selectionBoxRef = useRef();
  const toothAreaRef = useRef<HTMLDivElement>(null);

  //   useEffect(() => {
  //     if ( startPoint && endPoint ) {
  //         let svg = document.getElementById("svg-dr");
  //         let offset = getOffset(svg)
  //         if (offsetLeft !== offset.left) {
  //             setOffsetLeft(offset.left)
  //         }
  //         if (offsetTop !== offset.top) {
  //             setOffsetTop(offset.top)
  //         }
  //     }
  //     // console.log("useEffect DentalRecord offset", offsetLeft, offsetTop, props.selectionBox)
  // }, [startPoint, endPoint])

  // เปลี่ยน Clinical Finding ยกเลิกออกจากMode ใดๆ
  useEffect(() => {
    if (props.clinicalFindingId) {
      // setChooseSupernumerary(false);
      // setChooseMissingTeeth(false);
    }
  }, [props.clinicalFindingId]);

  useEffect(() => {
    if (props.masterData?.organ?.items) {
      let organ = props.masterData?.organ?.items?.filter((item) => item.tissue === "tooth");
      setOrganMaster(organ);
    }
  }, [props.masterData.organ]);

  useEffect(() => {
    if (props.superteeth?.length > 0) {
      const toothList = props.superteeth.map((item) => superTeethTSHumanToTSOrgan(item));
      setSuperTeethPatient(toothList);
    } else {
      setSuperTeethPatient([]);
    }
  }, [props.superteeth]);

  useEffect(() => {
    if (["DiagnosisHistory", "TreatmentHistory"].includes(props.sub)) {
      const showBabytooth = clinicalHasBabyTooth(props.clinicalFindings, props.masterData?.organ?.items);
      setHideBabyTooth(!showBabytooth);
    } else {
      setHideBabyTooth(props.hideBabyTooth);
    }
  }, [props.hideBabyTooth, props.sub, props.clinicalFindings, props.masterData?.organ?.items]);

  useEffect(() => {
    // console.log("DentalRecord1 useEffect props.controller?.data?.clinicaltags?.items", props.controller?.data?.clinicaltags?.items)
    const clinicalTagItems = props.controller?.data?.clinicaltags?.items || props.masterData?.clinicaltags?.items;

    if (clinicalTagItems?.length > 0) {
      let toothTags = clinicalTagItems.filter((item) => item.diagram === "teeth");
      toothTags.map((item) => {
        let prepare = item;
        prepare.detail = item.is_group ? !item.is_group : item.detail;
        prepare.color = item.colors ? item.colors : item.color;
        return prepare;
      });
      setColorTag(toothTags);
      // console.log("DentalRecord1useEffect props.controller?.data?.clinicaltags?.items setColorTag colorTag", toothTags);
    }
  }, [props.controller?.data?.clinicaltags?.items, props.masterData?.clinicaltags?.items]);

  const abbrSurfaceDict = useMemo(() => {
    return toothDetails.reduce(
      (result, item) => ({
        ...result,
        [`${item.q}${item.i}`]: item.surfaceName.map((name) => (name === "Labial" ? "La" : name === "Palatal" ? "Pa" : name === "Lingual" ? "Li" : name[0])),
      }),
      {} as Record<string, string[]>,
    );
  }, []);

  // console.log("DentalRecord1 props: ->", props)
  // console.log("DentalRecord1 props.controller.data",props.controller.data , "colorTag", colorTag)

  let selectingBoxStyle: CSSProperties | null = null;
  let settings = {};
  let spot = [];

  const handleSelectAll = (teethSet: string[]) => {
    if (props.clinicalFindingIndex !== null && props.clinicalFindingId) {
      let tooth = deTinyLocation2(teethSet, organMaster);
      console.log("hanndleSelectAll:", tooth);
      tooth = tooth.map((item) => {
        let tt = organMaster.find((o) => item === o.nickName);
        tt.location = tt.nickName;
        return tt;
      });
      console.log("select item", tooth);
      props.onEvent({ message: "AddLocation", params: { items: tooth, teethSet } });
    }
  };

  settings["q1btn"] = {
    ...settings["q1btn"],
    cursor: "pointer",
    pointerEvents: "auto",
    visibility: props.selectorMode ? "visible" : "hidden",
    onClick: () => handleSelectAll(["11-18"]),
  };
  settings["q2btn"] = {
    ...settings["q2btn"],
    cursor: "pointer",
    pointerEvents: "auto",
    visibility: props.selectorMode ? "visible" : "hidden",
    onClick: () => handleSelectAll(["21-28"]),
  };
  settings["q3btn"] = {
    ...settings["q3btn"],
    cursor: "pointer",
    pointerEvents: "auto",
    visibility: props.selectorMode ? "visible" : "hidden",
    onClick: () => handleSelectAll(["31-38"]),
  };
  settings["q4btn"] = {
    ...settings["q4btn"],
    cursor: "pointer",
    pointerEvents: "auto",
    visibility: props.selectorMode ? "visible" : "hidden",
    onClick: () => handleSelectAll(["41-48"]),
  };
  settings["ubtn"] = {
    ...settings["ubtn"],
    cursor: "pointer",
    pointerEvents: "auto",
    visibility: props.selectorMode ? "visible" : "hidden",
    onClick: () => handleSelectAll(["11-18", "21-28"]),
  };
  settings["lbtn"] = {
    ...settings["lbtn"],
    cursor: "pointer",
    pointerEvents: "auto",
    visibility: props.selectorMode ? "visible" : "hidden",
    onClick: () => handleSelectAll(["31-38", "41-48"]),
  };
  settings["fmbtn"] = {
    ...settings["fmbtn"],
    cursor: "pointer",
    pointerEvents: "auto",
    visibility: props.selectorMode ? "visible" : "hidden",
    onClick: () => handleSelectAll(["11-18", "21-28", "31-38", "41-48"]),
  };

  // const handleMissing = (e) => {
  //   console.log(" handleMissing !!!!! ", e.target);
  //   let q = e.target.id.slice(1, 2);
  //   let i = e.target.id.slice(2, 3);
  //   props.setMissingTooth({ q: Number(q), i: Number(i) });
  // };

  const handleSetSupernumerary = (key: string) => async (e) => {
    // resolve ก่อน await เพราะ React synthetic event อาจถูก reuse
    const items = props.selectorMode ? resolveSelectedItems(e) : null;
    const tooth = superTeethTSOrganToTSHuman(key); // e.g. TS34B, TS31/41
    const isNewSuper = !props.superteeth?.includes(tooth);
    const selectedRowIndex = props.selectorMode ? props.clinicalFindingIndex : null;
    const selectedRowId = props.clinicalFindingId;

    const saveSelectedRow = async () => {
      if (selectedRowId) {
        await props.onEvent({ message: "SaveClinicalFindingById", params: { id: selectedRowId, card: DIAGNOSIS_TODAY_CARD } });
      }
    };

    const toggleLocationOnSelectedRow = () => {
      if (items && selectedRowIndex !== null) {
        props.onEvent({ message: "ToggleLocation", params: { items, clinicalFindingIndex: selectedRowIndex } });
      }
    };

    // Add ใหม่ + ไม่ได้เลือก row → ให้ backend auto-create supernumerary exam row ให้
    if (isNewSuper && selectedRowIndex === null) {
      await props.setSuperTooth(tooth, { createExam: true });
      return;
    }

    // Add ใหม่ + เลือก row อยู่ → save pending edit ก่อน (กัน GetExamination refetch ทับ),
    // แล้วใส่ super location เข้า row เดิม
    if (isNewSuper) {
      await saveSelectedRow();
      await props.setSuperTooth(tooth, { createExam: false });
      toggleLocationOnSelectedRow();
      await saveSelectedRow();
      return;
    }

    // มีอยู่แล้ว + อยู่ใน selectorMode → toggle location เข้า row ที่เลือก (ไม่ unset)
    if (props.selectorMode) {
      toggleLocationOnSelectedRow();
      return;
    }

    // มีอยู่แล้ว + ไม่อยู่ใน selectorMode → unset supernumerary
    await props.setSuperTooth(tooth);
  };

  const handleAddSupernumerary = (key) => (e) => {
    console.log(" handleAddSupernumerary to Location", key);
  };

  //   const getOffset = (element) => {
  //     let bound = element.getBoundingClientRect();
  //     let html = document.documentElement;
  //     let offset = {
  //         top: bound.top + window.pageYOffset - html.clientTop,
  //         left: bound.left + window.pageXOffset - html.clientLeft
  //     }
  //     // console.log(" getOffset offset", offset)
  //     return offset;
  // }

  const priorityColor = (colorList?: string[], defaultColor?: string[]) => {
    // แก้จากเดิม
    // (i) Cavity (แดง) ร่วมกับ เลือก Filling (น้ำเงิน) ใน location เดียวกัน ให้แสดง สีน้ำเงินขอบแดง
    // (ii) Cavity (แดง) ร่วมกับ เลือกDirect restoration (เหลือง) ใน location เดียวกัน ให้แสดง สีเหลืองขอบแดง
    // (iii) การแสดง Clinical finding บน dental diagram ที่ไม่เข้ากรณี i และ ii ให้ แสดงสี หรือสัญลักษณ์ตามการลง Examination ลำดับหลังสุด
    // เป็น
    // 1. กากบาท สีดำ (Congenital absence & Extracte tooth)  //grey
    // 2. สีดำ (Clinical absence, Partial eruption, Unerupted tooth) //grey
    // 3. Implant teal
    // 4.1. Filling + Cavity น้ำเงินขอบแดง  // blue
    // 4.2. Indirect restoration + Cavity เหลืองขอบแดง // yellow
    // 5. เงื่อนไข อื่น ๆ ให้แสดงตาม Clinical finding ที่ลงหลังสุด
    // console.log(" priorityColor colorList: ", colorList)

    let colorTagList = [...colorList] ?? [];

    // console.debug("finishColor priorityColor Pre colorTagList: ", colorTagList);

    if (colorTagList?.length > 0) {
      // // 50594
      // if(colorTagList.includes("pink")){
      //   // missing tooth and clinical in missing
      //   return ["pink"]
      // } else if (colorTagList.includes("grey")){
      //   // implant tooth
      //   return ["grey"]
      // } else if (colorTagList.includes("red") && colorTagList.length > 1) {
      //   if (colorTagList.includes("blue")){
      //     colorTagList = ["blue", "red"];
      //   }else if (colorTagList.includes("yellow")){
      //     colorTagList = ["yellow", "red"];
      //   }else{
      //     colorTagList = [colorTagList.pop()];
      //   }
      // } else {
      //   colorTagList = [colorTagList.pop()];
      // }

      if (colorTagList.includes("grey")) {
        // console.log("priorityColor Return Gray")
        return ["grey"];
      } else if (colorTagList.includes("green")) {
        // console.log("priorityColor Return green")
        return ["green"];
      } else if (colorTagList.includes("red") && colorTagList.length > 1) {
        let list = colorTagList.filter((item) => item !== "red" && item !== "black");
        // maybe stoke
        if (list.length > 0) {
          // have second
          let primaryColor = list.reverse().find((item) => item !== "red");
          colorTagList = [primaryColor, "red"];
          // console.log("colorTagList after inject red", colorTagList)
        } else {
          colorTagList = ["red"];
          // console.log("colorTagList else colorTagList: ", colorTagList)
        }
      } else {
        colorTagList = [colorTagList.pop()];
        // console.log("colorTagList else colorTagList: ", colorTagList)
      }
      // console.debug("finishColor priorityColor is colorTagList", colorTagList);
      return colorTagList;
    }

    // if (colorTagList?.length > 0) {
    //   console.log("colorTagList if", colorTagList)
    //   // colorTagList = [...new Set(colorTagList)]  // lost last info
    //   // priority
    //   if (colorTagList.includes("red") && colorTagList.length > 1) {
    //     // maybe stoke
    //     if (colorTagList.filter(item => item !== "red").length > 0) {
    //       // have second
    //       let primaryColor = colorTagList.reverse().find(item => item !== "red")
    //       colorTagList = [primaryColor, "red"]
    //       console.log("colorTagList after inject red", colorTagList)
    //     } else {
    //       colorTagList = [colorTagList.pop()]
    //       console.log("colorTagList else colorTagList: ", colorTagList)
    //     }
    //   } else {
    //     colorTagList = [colorTagList.pop()]
    //     console.log("colorTagList else colorTagList: ", colorTagList)
    //   }
    //   console.log(" priorityColor is colorTagList", colorTagList)
    //   return colorTagList
    // }
    //console.debug("finishColor priorityColor is defaultColor", defaultColor);
    return defaultColor;
  };

  const getColorListFrom = (tags: string, defaultColor: string) => {
    let tagsList = tags.split(",").map((item) => item.trim());
    //console.debug("finishColorgetColorListFrom finishColor priorityColor colorTag: ", colorTag);
    let colorTagList = tagsList.map((tag) => colorTag.find((colorT) => colorT.name === tag) ?? "").filter((item) => item);
    colorTagList = colorTagList.map((item) =>
      item.is_group ? item.color : colorTag.filter((colorT) => colorT.is_group).find((colorT) => colorT.name === item.group).color,
    );
    //console.debug("getColorListFrom finishColor priorityColor colorTagList: ", colorTagList);
    colorTagList = colorTagList.flat().map((item) => item.toLowerCase());

    let prioColorList = priorityColor(colorTagList, [defaultColor]);
    //console.debug("getColorListFrom finishColor priorityColor Return ColorList prioColorList", prioColorList);
    return prioColorList;
  };

  /********************************************************************/
  /******* Mouse Down *******/
  /********************************************************************/
  const resolveSelectedItems = (e: any): SelectedItem[] | null => {
    if (!e.target.id || e.target?.id.substring(0, 1) !== "T") return null;

    const q = e.target.id.substring(1, 2);
    const i = e.target.id.substring(2, 3);
    const numberI = Number(i);
    const numberQ = Number(q);
    const section = e.target.id.substring(4, 5);

    if (section === "c") {
      const superSection = e.target.id.substring(5)?.toUpperCase();
      const supertoothOrgan = organMaster?.filter((item) => item.id?.includes("supertooth"));
      const surfaceName = supertoothOrgan.find((item) => item.id === "supertooth" + q + i + superSection);
      if (!surfaceName) return null;
      const location = surfaceName.nickName;
      return [{ q: numberQ, i: numberI, location }];
    }

    if (section !== "5") {
      const surfaceName = toothDetails.find((item) => item.i === numberI && item.q === numberQ)?.surfaceName[section];
      if (!surfaceName) return null;
      const location = q + i + getAbbrSurface(surfaceName);
      return [{ q: numberQ, i: numberI, location }];
    }

    const surfaceNameList = toothDetails.find((item) => item.i === numberI && item.q === numberQ)?.surfaceName;
    return surfaceNameList.slice(0, -1).map((item) => ({
      q: numberQ,
      i: numberI,
      location: q + i + (item ? getAbbrSurface(item) : item),
    }));
  };

  const handleMouseDown = (e: any) => {
    if (openGallery || openPhysicalExam) return;

    e.preventDefault();
    e.stopPropagation();

    if (props.selectorMode) {
      const items = resolveSelectedItems(e);
      if (items) setSelectedItems(items);

      setSelecting(true);
      setStartPoint({ x: e.clientX, y: e.clientY });
      e.persist();
    } else {
      if (!chooseSupernumerary) {
        props.onEvent({ message: "SelectedDiagramItem", params: { selectedDiagram: e.target?.id } });
      }
    }
  };

  /********************************************************************/
  /******* Mouse Move *******/
  /********************************************************************/
  const handleMouseMove = (e: any) => {
    if (!selecting) {
      return;
    }
    // var bounds = e.target.getBoundingClientRect();
    // var x = e.clientX - bounds.left;
    // var y = e.clientY - bounds.top;

    // var x = e.pageX - e.target.offset.left
    // var y = e.pageY - e.target.offset.top

    // console.log("Prepare Selected onmouse x ,y , e.PageX, e.PageY ",e )
    const currentPoint = { x: e.clientX, y: e.clientY };

    setEndPoint(currentPoint);
    // console.log(" props.superteeth", props.superteeth) // ["T38S", "T38SL", "T65S", "T36SN", "T36S", "T36SS", "T37S"]
    let items = getSelectedItems(selecting, selectionBoxRef, startPoint, currentPoint, hideBabyTooth, superteethPatient);
    // console.log("Just Click onMouseMove ", items)
    if (items.length > 0) {
      setSelectedItems(items);
      // console.log("Just Click item ", items)
    } else if (items.length === 0) {
      setSelectedItems([]);
    }
  };

  /********************************************************************/
  /******* Mouse Leave *******/
  /********************************************************************/
  const handleMouseLeave = () => {
    if (!selecting) {
      return;
    }
    handleFinishDragMouse();
  };

  /********************************************************************/
  /******* Mouse Up *******/
  /********************************************************************/
  const handleMouseUp = (e: any) => {
    if (openGallery || openPhysicalExam) {
      return;
    }
    handleFinishDragMouse();
  };

  /********************************************************************/
  /******* Mouse Over / Mouse Leave Hover *******/
  /********************************************************************/
  const handleMouseOver = (e, key) => {
    const organ = spot?.find((item) => item.location === key.slice(1));

    tooltipRef?.show?.({
      target: e.target,
      key,
      organ,
      masterData: props.masterData,
      selector: ".tooth-area.svg-zoom-out",
      zoomElement: toothAreaRef.current,
      content: () => superTeethSOrganToSHuman(organ?.location),
    });
  };

  const handleMouseLeaveHover = () => {
    tooltipRef.current.style.display = "none";
  };

  /********************* Hide Baby Teeth Case ************************/
  if (hideBabyTooth) {
    spot = HotSpotNoBaby;
  } else {
    spot = HotSpot;
  }

  // console.log(" spot", spot)
  /********************* Super Teeth  ************************/
  // Clear All
  // console.log(" spot ", spot )
  spot
    .filter((item) => item.location.startsWith("S"))
    .forEach((item) => {
      const key = "T" + item.location;
      settings[key] = {
        visibility: "hidden",
      };
      settings[key + "t"] = {
        visibility: "hidden",
      };
    });

  // console.log("settings", settings, "props.superteeth", props.superteeth)
  // Add Super from db

  for (const key of superteethPatient || []) {
    settings[key] = {
      ...settings[key],
      visibility: "visible",
      fill: "white",
    };
    settings[key + "t"] = {
      ...settings[key + "t"],
      visibility: "visible",
      fill: "black",
    };
  }

  /*******************************************************************/
  /************* Normal Case ** or Choose Super Numerary *************/
  /*******************************************************************/
  // Enabled Supernumerary
  if (chooseSupernumerary) {
    /********************* Choose Super Numerary *********************/
    for (const key in settings) {
      if (Object.prototype.hasOwnProperty.call(settings, key)) {
        if (key.includes("SL") || key.includes("S")) {
          if (settings[key].visibility === "visible") {
            if (!props.selectorMode) {
              settings[key] = {
                fill: "red",
                onClick: handleSetSupernumerary(key),
                cursor: "pointer",
              };
              if (key.includes("t")) {
                settings[key] = {
                  fill: "white",
                  onClick: handleSetSupernumerary(key),
                  cursor: "pointer",
                };
              }
            } else {
              settings[key] = {
                ...settings[key],
                onClick: handleSetSupernumerary(key),
                cursor: "pointer",
              };
            }
          } else {
            settings[key] = {
              visibility: "visible",
              fill: "gray",
              color: "black",
              cursor: "pointer",
              onClick: handleSetSupernumerary(key),
            };
            if (key.includes("t")) {
              settings[key] = {
                visibility: "visible",
                fill: "white",
                color: "black",
                cursor: "pointer",
                onClick: handleSetSupernumerary(key),
              };
            }
          }
        }
      }
    }
  }

  // console.log("Color Check render!!  props.clinicalFindingIndex", props.clinicalFindingIndex)

  if (props.selectorMode) {
    /*******************************************************************/
    /************************* selectorMode Selecting Case *************/
    /*******************************************************************/
    if (selecting) {
      var parentNode = selectionBoxRef?.current || null;
      // console.log(parentNode.offsetLeft)
      if (typeof parentNode !== "undefined" && parentNode && startPoint && endPoint) {
        const parentRect = getViewportRect(parentNode);
        const zoom = getEffectiveZoom(parentNode) || 1;

        var left = (Math.min(startPoint.x, endPoint.x) - parentRect.left) / zoom;
        var top = (Math.min(startPoint.y, endPoint.y) - parentRect.top) / zoom;
        var width = Math.abs(startPoint.x - endPoint.x) / zoom;
        var height = Math.abs(startPoint.y - endPoint.y) / zoom;


        selectingBoxStyle = {
          position: "absolute",
          left: left,
          top: top,
          width: width,
          height: height,
          border: "solid black 1px",
          pointerEvents: "none",
          zIndex: 1,
        };
      }
    } else {
      selectingBoxStyle = null;
    }

    // console.log(" DentalRecord1 ")
    // From clinicla Findings
    // console.log("props.clinicalFindingIndex", props.clinicalFindingIndex)
    // console.log("props.clinicalFindings", props.clinicalFindings)
    let organsWithMulitSelected = getOrgansWithRecord(organMaster, [props.clinicalFindings[props.clinicalFindingIndex]]);

    // console.log("props.clinicalFindingIndex", props.clinicalFindingIndex)

    for (const organ of organsWithMulitSelected) {
      const key = "T" + organ;
      settings[key] = { ...settings[key], fill: "orange", opacity: 1 };
    }

    // From Selecting Item
    for (const item of selectedItems) {
      let toothLocation = superTeethSHumanToSOrgan(item.location); // S13/14 to S13S14
      const key = "T" + toothLocation;
      settings[key] = { ...settings[key], fill: "#5bd05b", opacity: 1 };
    }

    /********************* Super Teeth  ************************/
    // Add Super from db  and add Selected
    // let selectedSuperTeeth = props.selectedClinicalFinding.location?.split(",").filter(item => item.includes("S") || item.includes("SL"))
    if (!chooseSupernumerary) {
      for (const key of superteethPatient || []) {
        settings[key] = {
          ...settings[key],
          onClick: handleAddSupernumerary(key),
        };
        settings[key + "t"] = {
          ...settings[key + "t"],
          onClick: handleAddSupernumerary(key),
        };
      }
    }

    // console.log("settings ", settings)

    let fullTeethEditing: any[] = organsWithMulitSelected.filter((item) => !item.startsWith("S")).map((item) => item.slice(0, 2));
    let superTeethEditing = organsWithMulitSelected.filter((item) => item.startsWith("S"));
    fullTeethEditing = [...Array.from(new Set(fullTeethEditing))];
    superTeethEditing = [...Array.from(new Set(superTeethEditing))];
    // console.log("Check superTeethEditing", superTeethEditing)
    /********************* Missing Teeth  ************************/
    for (const t of props.missingteeth || []) {
      // const key = "T" + `${t.q}${t.i}`;
      let key = "T";
      if (t.nickName.startsWith("S")) {
        // console.log("Check t.nickName", t.nickName)
        // Super teeth
        let name = t.nickName.replace("/", "S");
        if (!superTeethEditing.includes(name)) {
          key = key + name;
          settings[key] = {
            ...settings[key],
            missing: "true",
            visibility: "hidden",
          };
          settings[key + "t"] = {
            ...settings[key + "t"],
            missing: "true",
            visibility: "hidden",
          };
        }
      } else {
        // on Edit no hide teeth
        if (!fullTeethEditing.includes(`${t.q}${t.i}`)) {
          // Full teeth
          key = key + `${t.q}${t.i}`;
          // Big circle
          settings[key + "C"] = {
            ...settings[key + "C"],
            missing: "true",
            visibility: "hidden",
          };

          let oMaster = props.masterData?.organ?.items
            .filter((item: any) => item.tissue === "tooth")
            .filter((item: any) => item.children?.length === 5)
            .find((item: any) => item.i === t.i && item.q === t.q);
          oMaster.children.forEach((item: any) => {
            let key = item.replace("tooth", "T");
            // console.log("orgainMaster key", key )
            settings[key] = {
              ...settings[key],
              missing: "true",
              visibility: "hidden",
            };
          });
        }
      }
    }



    /********************* Implant Teeth  ************************/
    for (const t of props.implantteeth || []) {
      const key = "T" + `${t.q}${t.i}`;
      settings[key] = {
        ...settings[key],
        implant: true,
      };
    }
  } else {
    /********************* Normal *********************/

    // console.log("Color props.clinicalFindingIndex ", props.clinicalFindingIndex)
    // console.log("Color props.filterClinicalFindingIds ", props.filterClinicalFindingIds)
    if (props.clinicalFindingIndex !== null) {
      // Selected 1 Row
      let colorList;
      if (props.clinicalFindings[props.clinicalFindingIndex]?.clinicaltags) {
        colorList = getColorListFrom(props.clinicalFindings[props.clinicalFindingIndex]?.clinicaltags, "orange");
      } else {
        colorList = ["orange"];
      }
      // console.log("Color 1 row colorList", colorList, props.clinicalFindings[props.clinicalFindingIndex])

      let organsWithRecord = getOrgansWithRecord(organMaster, [props.clinicalFindings[props.clinicalFindingIndex]]);

      // console.log("colorList: : organsWithRecord #1",key,colorList, organsWithRecord)
      // Do Color
      for (const organ of organsWithRecord) {
        /// All Organ throw here
        const key = "T" + organ;

        // แสดงขอบ surface
        const lineKeys = getSurfaceBorderLine(organ, abbrSurfaceDict, organsWithRecord);

        lineKeys.forEach((key) => {
          settings[key] = {
            ...(colorList?.length > 1 && { stroke: colorList[1], strokeWidth: 2, opacity: 1 }),
          };
        });

        settings[key] = {
          ...settings[key],
          fill: colorList[0],
          ...(colorList?.length > 1 && { stroke: colorList[1], strokeWidth: 2 }),
          opacity: 1,
        };
      }
    } else {
      let organsWithRecord;
      // Normal Case use Filter

      // organsWithRecord = getOrgansWithRecord(
      //   organMaster,
      //   props.clinicalFindings.filter(item => props.filterClinicalFindingIds.includes(item.id))
      // );
      // // Do Color
      // for (const organ of organsWithRecord) {
      //   /// All Organ throw here
      //   const key = "T" + organ;
      //   settings[key] = {
      //     ...settings[key],
      //     fill: "orange",
      //     opacity: 1,
      //   };
      // }

      // Normal Case use Filter

      // console.log("props.filterClinicalFindingIds ", props.filterClinicalFindingIds)
      let fcfs = props.clinicalFindings.filter((item) => props.filterClinicalFindingIds.includes(item.id));

      const organsWithRecordAll = getOrgansWithRecord(organMaster, fcfs);
      //console.debug("finishColor priorityColor Color All row fcfs: ", fcfs);
      fcfs.forEach((fcf) => {
        let colorList = [];
        //console.debug("finishColor priorityColor fcf", fcf);

        // TODO : have bug when first cf has clinical tag then (RED color) after next row no clincical tag then override with orange
        if (fcf?.clinicaltags) {
          // console.log(" fcf?.clinicaltags ", fcf?.clinicaltags)
          colorList = getColorListFrom(fcf?.clinicaltags, "orange");
        } else {
          colorList = ["orange"];
        }

        // console.log("Color colorList: ", colorList, "fcf?.clinicaltags: ", fcf?.clinicaltags)
        //console.debug("!!!!!!!!!!!!!!!!! finishColor priorityColor colorList: :", colorList);
        // console.log("colorList: : fcf", fcf)

        organsWithRecord = getOrgansWithRecord(organMaster, [fcf]);
        // Do Color
        // console.debug("finishColor priorityColor colorList: : organsWithRecord #2", organsWithRecord, organsWithRecordAll, fcf);
        for (const organ of organsWithRecord) {
          /// All Organ throw here
          const key = "T" + organ;
          //console.debug("finishColor priorityColor key: ", key);
          //console.debug("finishColor priorityColor settings: ", settings[key]);

          let finishColor: any[] = [...colorList];
          // Combile Color in Vertical
          if (settings[key] && settings[key].fill !== "white") {
            //console.debug("colorList: ", colorList);
            let primaryColor = settings[key].fill ?? "";
            //console.debug("primaryColor: ", primaryColor);
            let strokeColor = settings[key].stroke ?? "";
            //console.debug("strokeColor: ", strokeColor);
            let combileColor = [primaryColor, strokeColor, ...colorList].filter((item) => item).filter((item) => item !== "orange" && item !== "black");
            //console.debug("combileColor: ", combileColor);
            finishColor = priorityColor(combileColor, ["orange"]);
            // if (key.includes("18")) {
            //   console.log('combileColor: ',key, combileColor, colorList);
            // }
          }

          //console.debug("finishColor Vertical colorList", key, colorList);
          // แสดงขอบ surface
          const lineKeys = getSurfaceBorderLine(organ, abbrSurfaceDict, organsWithRecordAll);

          lineKeys.forEach((key) => {
            settings[key] = {
              ...(finishColor?.length > 1 && { stroke: finishColor[1], strokeWidth: 2, opacity: 1 }),
            };
          });

          settings[key] = {
            ...settings[key],
            fill: finishColor[0],
            ...(finishColor?.length <= 1 && { stroke: "black", strokeWidth: 1 }),
            ...(finishColor?.length > 1 && { stroke: finishColor[1], strokeWidth: 2 }),
            opacity: 1,
          };
          //console.debug("finishColor priorityColor key", key, settings[key]);
        }
      });
    }

    // console.log("settings:", settings);
    // Filter
    if (props.filterItem) {
      /// T42-2
      // console.log(" props.filterItem", props.filterItem)

      let q = props.filterItem.substring(1, 2);
      let i = props.filterItem.substring(2, 3);
      let section = props.filterItem.substring(4, 5);

      let surfaceName = toothDetails.find((item) => item.q === Number(q) && item.i === Number(i))?.surfaceName[Number(section)];
      if (surfaceName) {
        let abbr = getAbbrSurface(surfaceName);
        let key = "T" + q + i + abbr;
        settings[key] = {
          ...settings[key],
          fill: "green",
        };
      } else if (section === "c") {
        //super T36-css
        let superSection = props.filterItem.substring(5)?.toUpperCase();
        // let location = q + i + superSection
        let key = "T" + q + i + superSection;
        settings[key] = {
          ...settings[key],
          fill: "green",
        };
      }
    }

    /*************************************************************************
     *
     *     FIND MISSING TEETH and IMPLANT TEETH
     *
     *
     *
     *************************************************************************/

    let missingTeethOrgan: any[] = props.missingteeth || [];
    //  let partialMissingTeethOrgan: any[] = [];
    let implantTeethOrgan: any[] = props.implantteeth || [];

    if (props.sub === "DiagnosisToday" || props.sub === "TreatmentToday") {
      // Current Visit
      // History Review (Visit Tab)
    } else {
      //  console.log("DiagnosisHistory case and TreatmentToday case")
      let missingTeeths: any[] = [];
      //  let partialMissingTeeths: any[] = [];
      let implantTeeths: any[] = [];
      const organItems = props.masterData?.organ?.items;
      for (const exam of props.clinicalFindings) {
        if (exam.clinicaltags && exam.clinicaltags.split(",").filter((o: any) => MissingToothClinical.includes(o.trim())).length > 0) {
          let teethLocations = exam.locations_name.split(",").map((item: any) => item.trim());
          missingTeeths = missingTeeths.concat(getOnlyFullTeeth(teethLocations, organItems).map((item) => item.nickName));
        }

        //  if (exam.clinicaltags && exam.clinicaltags.split(",").filter((o: any) => PartialMissingToothClinical.includes(o.trim())).length > 0) {
        //    let teethLocations = exam.locations_name.split(",").map((item: any) => item.trim());
        //    partialMissingTeeths = partialMissingTeeths.concat(getOnlyFullTeeth(teethLocations, organItems).map((item) => item.nickName));
        //  }

        if (exam.clinicaltags && exam.clinicaltags.split(",").filter((o: any) => "Implant" === o.trim()).length > 0) {
          let teethLocations = exam.locations_name
            .split(",")
            .map((item: any) => item.trim())
            .filter((item: any) => !item.startsWith("S"));
          implantTeeths = implantTeeths.concat(getOnlyFullTeeth(teethLocations, organItems).map((item) => item.nickName));
        }
      } // end for

      // // Unique
      missingTeeths = Array.from(new Set(missingTeeths));
      implantTeeths = Array.from(new Set(implantTeeths));
      //  partialMissingTeeths = Array.from(new Set(partialMissingTeeths));

      // DiagnosisToday Visit Tab
      if (props.sub === "DiagnosisHistory" && props.historyReviewSubTab === 0) {
        missingTeethOrgan = missingTeeths.map((item) => {
          return props.masterData?.organ?.items.find((o: any) => o.nickName === item);
        });
      }

      //  partialMissingTeethOrgan = partialMissingTeeths.map((item) => {
      //    return props.masterData?.organ?.items.find((o:any) => o.nickName === item);
      //  });

      implantTeethOrgan = implantTeeths.map((item) => {
        return props.masterData?.organ?.items.find((o: any) => o.nickName === item);
      });
    }

    /********************* Missing Teeth onClick on Cross ************************/
    // console.log("!!!!  props.missingteeth", props.missingteeth)
    for (const t of missingTeethOrgan || []) {
      // const key = "T" + `${t.q}${t.i}`;
      // console.log("props.missingteeth t: ", t)
      let key = "T";
      if (t.nickName.startsWith("S")) {
        // Super teeth
        key = key + t.nickName.replace("/", "S");
        settings[key] = {
          ...settings[key],
          missing: "true",
          visibility: "hidden",
        };
        settings[key + "t"] = {
          ...settings[key + "t"],
          missing: "true",
          visibility: "hidden",
        };
      } else {
        // Full teeth
        key = key + `${t.q}${t.i}`;
        // Big circle
        settings[key + "C"] = {
          ...settings[key + "C"],
          missing: "true",
          visibility: "hidden",
        };

        let oMaster = props.masterData?.organ?.items
          .filter((item: any) => item.tissue === "tooth")
          .filter((item: any) => item.children?.length === 5)
          .find((item: any) => item.i === t.i && item.q === t.q);
        oMaster.children.forEach((item: any) => {
          let key = item.replace("tooth", "T");
          // console.log("orgainMaster key", key )
          settings[key] = {
            ...settings[key],
            missing: "true",
            visibility: "hidden",
          };
        });
      }
    }

    /********************* Implant Teeth  ************************/

    // if (!props.plate) {
    //   console.log(" props.implantteeth", props.implantteeth);
    // }
    // DiagnosisHistory, DiagnosisToday, TreatmentToday
    // console.log("props.sub", props.sub)

    // Do implant
    for (const t of implantTeethOrgan) {
      const key = "T" + `${t.q}${t.i}`;
      // console.log("settings", t, settings);
      let fragment = Object.keys(settings)
        .filter((item) => item.includes(key))
        .filter((item) => item != key);
      let isHasGreen = 0;
      // console.log("implant fragment", fragment);
      for (const frag of fragment) {
        if (settings[frag].fill === "green") {
          isHasGreen++;
        } else {
          isHasGreen--;
        }
      }
      // console.log("implant isHasGreen", isHasGreen);
      if (isHasGreen === 5) {
        settings[key] = {
          ...settings[key],
          implant: true,
        };
      }
    }
  }

  /********************* Missing Teeth onClick on Teeth  ************************/
  spot.forEach((item) => {
    const key = "T" + `${item.location}`;
    // if (chooseMissingTeeth) {
    //   // settings[key] = {
    //   //   ...settings[key],
    //   //   onClick: handleMissing,
    //   // };
    // } else {
    // Only 5 part of tooth not cover whole circle
    settings[key] = {
      ...settings[key],
      // onClick : () => { console.log( "Just Click at any tooth", key)},
      onMouseOver: (e) => {
        handleMouseOver(e, key);
      },
      onMouseLeave: (e) => {
        handleMouseLeaveHover(e, key);
      },
    };
    // }
  });

  // console.log("DentalRecord1.tsx settings: ", settings)

  const handleFinishDragMouse = () => {
    // console.log("handleFinishDragMouse ")
    if (props.selectorMode && selecting) {
      let items = getSelectedItems(selecting, selectionBoxRef, startPoint, endPoint, hideBabyTooth, superteethPatient);
      // console.log("handleFinishDragMouse  items ", items)
      // ลากคลุมฟันที่เลือกไว้แล้ว → ยกเลิกการเลือก (#74050)
      const organsWithMulitSelected = props.toggleOnDrag
        ? getOrgansWithRecord(organMaster, [props.clinicalFindings[props.clinicalFindingIndex]])
        : [];
      const hasMatchingLocations = items.some((item) => organsWithMulitSelected.includes(item.location));

      if (items.length > 0 && hasMatchingLocations) {
        props.onEvent({
          message: "ToggleLocation",
          params: { items: items.filter((item) => organsWithMulitSelected.includes(item.location)) },
        });
      } else if (items.length > 0) {
        props.onEvent({ message: "AddLocation", params: { items: items } });
      } else if (selectedItems.length > 0) {
        // ใน supernumerary mode ข้าม item ที่เป็น super (handleSetSupernumerary onClick จัดการไปแล้ว) แต่ยังให้ normal tooth toggle ได้ปกติ
        const itemsToToggle = chooseSupernumerary ? selectedItems.filter((item: any) => !item.location?.startsWith("S")) : selectedItems;
        if (itemsToToggle.length > 0) {
          props.onEvent({ message: "ToggleLocation", params: { items: itemsToToggle } });
        }
      }
    }
    setSelectedItems([]);
    setSelecting(false);
    setStartPoint(null);
    setEndPoint(null);
  };

  // let isPrimaryTeeth = false
  // let isPermanentTeeth = false
  let isNeedToggle = false; // To show relate image with
  if (
    props.sub === "DiagnosisHistory" &&
    props.historyReviewSubTab === 1 &&
    props.clinicalFindings &&
    props.clinicalFindingIndex &&
    props.clinicalFindings?.length > props.clinicalFindingIndex
  ) {
    const image = props.clinicalFindings[props.clinicalFindingIndex]?.image;
    if (image) {
      let isPrimaryTeeth = "primary_teeth" in image; // ฟันแท้ + ฟันน้ำนม
      let isPermanentTeeth = "permanent_teeth" in image; // ฟันแท้
      isNeedToggle = (hideBabyTooth && isPrimaryTeeth && !isPermanentTeeth) || (!hideBabyTooth && !isPrimaryTeeth && isPermanentTeeth);
    }
  }
  // console.log(" setting", settings)

  // if (props.plate) {
  //   console.log("props.plate props.sub", props.sub)
  //   console.log("props.plate props.historyReviewSubTab",  props.historyReviewSubTab)
  //   console.log("props.plate props.clinicalFindings",  props.clinicalFindings)
  //   console.log("props.plate  props.showDrawingChecked",   props.showDrawingChecked)

  // }
  return (
    <div
      className={chooseSupernumerary ? "choosesuper" : "normal"}
      ref={selectionBoxRef}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      onMouseUp={handleMouseUp}
      // issue 52820
      style={{ ...{ cursor: props.selectorMode ? "cell" : "default" }, padding: props.simple ? 0 : "20px 0px", display: "flex", flexDirection: "column", alignItems: "left", position: "relative" }}
    >
      {openPhysicalExam && !props.simple ? (
        <Modal
          onClose={() => {
            props.onEvent({ message: "CloseModalDentalExam", params: {} });
            props.setProp("dentalExamData", { ...props.dentalExamData });
            // props.setProp("activeEvaluation", "")
            setOpenPhysicalExam(false);
          }}
          onOpen={() => {
            setOpenPhysicalExam(true);
          }}
          open={openPhysicalExam}
          closeIcon={true}
          className="modal-dental-exam"
        >
          {" "}
          <DentalExam
            onEvent={props.onEvent}
            dentalCariesRisk={props.dentalCariesRisk}
            activeTabDentalCaries={props.activeTabDentalCaries}
            openModalAssessmentResults={props.openModalAssessmentResults}
            setProp={props.setProp}
            openModAssessment={props.openModAssessment}
            assessmentResults={props.assessmentResults}
            handleSaveAssessmentForm={() => {
              props.onEvent({ message: "SaveEvaluationForm", params: { form: "dentalCariesRisk" } });
              // props.onEvent({ message: "SaveAssessmentForm", params: {} })
              // props.setProp("activeEvaluation", "")
              setOpenPhysicalExam(false);
            }}
            dentalExamData={props.dentalExamData}
            handleSaveDentalExam={() => {
              props.onEvent({ message: "SaveEvaluationForm", params: { form: "dentalExamData" } });
              // props.setProp("dentalExamData", {})
              // props.setProp("activeEvaluation", "")
              setOpenPhysicalExam(false);
            }}
          />{" "}
        </Modal>
      ) : null}
      {/* alway show if in VisitTab under History review */}
      {selecting && <div style={selectingBoxStyle} />}

      <div
        ref={toothAreaRef}
        className="tooth-area svg-zoom-out"
        style={{ width: "fit-content", ...(props.svgZoom ? { zoom: props.svgZoom } : {}) }}
      >
        <Form>
          <ExaminationImageOverlay
            imageKey={hideBabyTooth ? "permanent_teeth" : "primary_teeth"}
            sub={props.sub}
            historyReviewSubTab={props.historyReviewSubTab}
            clinicalFindings={props.clinicalFindings}
            filterClinicalFindingIds={props.filterClinicalFindingIds}
            showDrawingChecked={props.showDrawingChecked}
            isNeedToggle={isNeedToggle}
            firstPosition={true}
            width="1200"
            height={hideBabyTooth ? "200" : "340"}
          >
            {props.sub === "DiagnosisHistory" && props.historyReviewSubTab === 1 && isNeedToggle ? (
              hideBabyTooth ? (
                <DentalRecord1UX {...props} settings={settings} startPoint={startPoint} endPoint={endPoint} />
              ) : (
                <DentalRecordNoBaby1UX {...props} settings={settings} startPoint={startPoint} endPoint={endPoint} />
              )
            ) : hideBabyTooth ? (
              <DentalRecordNoBaby1UX {...props} settings={settings} startPoint={startPoint} endPoint={endPoint} />
            ) : (
              <DentalRecord1UX {...props} settings={settings} startPoint={startPoint} endPoint={endPoint} />
            )}
          </ExaminationImageOverlay>
        </Form>
      </div>

      <Tooltip ref={(ref) => (tooltipRef = ref || { current: null })} />

      {/* issue 52820 */}
      {!props.hiddenEvaluation && !props.simple && (
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", width: "80%" }}>
          {/* feature #47588 remove missing teeth button <div
            onClick={() => {
              setChooseMissingTeeth(!chooseMissingTeeth);
              setChooseSupernumerary(false);
            }}
          >
            <Button
              disabled={props.selectorMode}
              circular
              icon
              style={{ color: "#ff0000", backgroundColor: "#F5D6D6", ...(chooseMissingTeeth && { color: "#F5D6D6", backgroundColor: "#ff0000" }) }}
            >
              <Icon name="close" />
            </Button>
            <span style={{ color: "#4f4f4f", cursor: "pointer", ...(chooseMissingTeeth && { color: "#FF0000", fontWeight: "bold" }), paddingLeft: "3px" }}>
              {" "}
              Missing teeth
            </span>
          </div> */}

          {/* <div onClick={ () => {
            setOpenGallery(true)
          }}>
            <Button disabled={props.selectorMode}  circular icon style={{color: "purple", backgroundColor: "pink"}}>
              <Icon name='edit outline' />
            </Button>
            <span style={{color:"#4f4f4f", paddingLeft: "3px"}}>Drawing</span>
          </div>  */}

          <div onClick={props.setHideBabyTooth}>
            <Button circular icon style={{ color: "white", backgroundColor: "#2D9CDB" }}>
              <Icon name={hideBabyTooth ? "unhide" : "hide"} />
            </Button>
            <span style={{ color: "#4f4f4f", paddingLeft: "3px" }}>{hideBabyTooth ? "Show Primary Teeth" : "Deciduous Teeth"}</span>
          </div>

          <div
            onClick={() => {
              setOpenPhysicalExam(true);
            }}
          >
            <Button disabled={props.selectorMode} circular icon style={{ color: "white", backgroundColor: "brown" }}>
              <Icon name="list" />
            </Button>
            <span style={{ color: "#4f4f4f", paddingLeft: "3px" }}>{intl.formatMessage({ id: "cukey75" })}</span>
          </div>

          <div
            onClick={() => {
              setChooseSupernumerary(!chooseSupernumerary);
              // setChooseMissingTeeth(false);
            }}
          >
            <Button
              // disabled={props.selectorMode}
              circular
              icon
              style={{ color: "#ff0000", backgroundColor: "#F5D6D6", ...(chooseSupernumerary && { color: "#F5D6D6", backgroundColor: "#ff0000" }) }}
            >
              <Icon name="sun" />
            </Button>
            <span style={{ color: "#4f4f4f", cursor: "pointer", ...(chooseSupernumerary && { color: "#FF0000", fontWeight: "bold" }), paddingLeft: "3px" }}>
              {intl.formatMessage({ id: "cukey199" })}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default DentalRecord1;

const getSelectedItems = (selecting: any, selectionBoxRef: any, startPoint: any, endPoint: any, hideBabyTooth: boolean, superTeethList: any[] = []) => {
  // superTeethList in S domain (TS37S38) easily to map
  let items: any[] = [];
  let spot: any[] = [];
  const svg = selectionBoxRef?.current?.querySelector?.("#svg-dr") as SVGSVGElement | null;

  if (svg && startPoint && endPoint) {
    const rect = getViewportRect(svg);
    // hotspot เป็นพิกัดของ SVG ขนาดออกแบบ (width="1200")
    const scale = rect.width / (svg.width?.baseVal?.value || 1200);

    const minX = Math.min(startPoint.x, endPoint.x);
    const maxX = Math.max(startPoint.x, endPoint.x);
    const minY = Math.min(startPoint.y, endPoint.y);
    const maxY = Math.max(startPoint.y, endPoint.y);

    if (hideBabyTooth) {
      // console.log(" Use No Baby Tooth ")
      spot = HotSpotNoBaby;
    } else {
      // console.log(" Use With Baby Tooth ")
      spot = HotSpot;
    }

    if (superTeethList.length > 0) {
      // console.log(" superTeethList", superTeethList);
      let subSuperTeeth = superTeethList.map((item) => item.substring(1));
      // spot with normal tooth + superteeth
      spot = spot.filter((item) => !item.location.includes("S") || subSuperTeeth.includes(item.location));
    } else {
      // sport with normal tooth
      spot = spot.filter((item) => !item.location.includes("S"));
    }

    items = spot.filter((item) => {
      const x = rect.left + item.x * scale;
      const y = rect.top + item.y * scale;

      return x > minX && x < maxX && y > minY && y < maxY;
    });
    // console.log(items) //[{i: 6, q: 3, x: 957, y: 297, location: "S35S36"}]

    items = items.map((item) => {
      return { i: item.i, q: item.q, location: superTeethSOrganToSHuman(item.location) };
    });
  }

  return items;
};

export const getLocationName = (item: any) => {
  const location =
    `${item.toothIdQ}${item.toothIdI}` +
    `${typeof item.toothIdSection === "number" ? " (" + getSurfaceName(item.toothIdQ, item.toothIdI, item.toothIdSection) + ")" : ""}`;
  return location;
};
